import { useDispatch, useSelector } from 'react-redux';
import FJEditFloatingPanel from '../view/FJEditFloatingPanel.jsx';
import { useEffect } from 'react';
import FJActionTextBasedEditingExtension from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditingExtension.js';

const FJEditFloatingPanelContainer = () => {
    const dispatch = useDispatch();
    const visible = useSelector(state => state.textEditFloatingPanel.editFloatingPanelVisible);
    const position = useSelector(state => state.textEditFloatingPanel.editFloatingPanelPosition);
    const showDelete = useSelector(state => state.textEditFloatingPanel.showDelete);
    const showRestore = useSelector(state => state.textEditFloatingPanel.showRestore);

    useEffect(() => {
        const __keydown = e => {
            const activeElement = document.activeElement;
            let isInput = false;
            if (activeElement) isInput = ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName);
            if (!isInput && (e.key === 'Backspace' || e.key === 'Delete')) {
                dispatch(FJActionTextBasedEditingExtension.deleteTextAction());
            }
        };
        if (visible) {
            document.addEventListener('keydown', __keydown);
        }
        return () => {
            document.removeEventListener('keydown', __keydown);
        };
    }, [visible]);

    const _onClick = () => {
        if (showDelete) dispatch(FJActionTextBasedEditingExtension.deleteTextAction());
        else dispatch(FJActionTextBasedEditingExtension.restoreTextAction());
    };

    if (!visible) return;

    return (
        <FJEditFloatingPanel showDelete={showDelete} showRestore={showRestore} position={position} onClick={_onClick} />
    );
};

export default FJEditFloatingPanelContainer;
